import { SubscriptionAccessoryDTO } from '../../common/types.js'
import { formatPrice } from '../../common/utils/utils.js'

export class SubscriptionAccessory {
    readonly data: SubscriptionAccessoryDTO
    readonly currencySymbol: string

    constructor(accessory: SubscriptionAccessoryDTO, currencySymbol: string) {
        this.data = accessory
        this.currencySymbol = currencySymbol
    }

    get name() {
        return this.data.accessory?.translation?.name || this.data.accessory?.sku
    }

    get discount() {
        if (!this.data.discount) {
            return ''
        }

        return formatPrice(this.data.discount, this.currencySymbol)
    }

    get quantity() {
        // NOTE: We need to make sure that the quantity is always at least 1
        if (this.data.quantityUnit === 'pieces') {
            return Math.max(1, this.data.quantity)
        }

        return 1
    }

    get totalPrice() {
        return formatPrice(this.data.priceWithVat, this.currencySymbol)
    }

    get unitPrice() {
        return formatPrice(this.data.priceWithVat / this.quantity, this.currencySymbol)
    }

    get sku() {
        return this.data.accessory?.sku
    }
}
